interface SupersimpleIconProps {
  size?: number;
}

export const SupersimpleIcon = ({ size = 16 }: SupersimpleIconProps) => {
  return (
    <img
      src="/logo-pinguin.svg"
      width={size}
      height={size}
      alt="Supersimple logo"
      style={{ display: 'block' }}
    />
  );
};
